var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAiAssistantSmallIc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9806 8.99048C25.1938 13.3534 23.7939 17.8797 19.8976 21.2394C16.0013 24.6224 9.60853 26.8389 5.29225 24.1791C0.975974 21.5427 -1.26382 13.9834 0.742662 8.52386C2.74915 3.04101 9.00191 -0.365357 13.9948 0.0312742C19.011 0.427906 22.7907 4.65087 23.9806 8.99048Z",
    fill: "#011E1E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1721_5227)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1138 9.36135H15.7427V18.7582H14.1138V17.1411C13.3032 18.382 12.1213 19.0033 10.5738 19.0033C9.26314 19.0033 8.14375 18.5226 7.21945 17.5648C6.29516 16.6071 5.83301 15.4384 5.83301 14.0607C5.83301 12.683 6.29516 11.5144 7.21945 10.5547C8.14375 9.59698 9.26314 9.11621 10.5738 9.11621C12.1213 9.11621 13.3032 9.7376 14.1138 10.9785V9.36135ZM10.7803 17.4261C11.7292 17.4261 12.5228 17.1031 13.1592 16.457C13.7956 15.8109 14.1138 15.0128 14.1138 14.0607C14.1138 13.1087 13.7956 12.3087 13.1592 11.6645C12.5228 11.0184 11.7273 10.6953 10.7803 10.6953C9.83325 10.6953 9.05668 11.0184 8.42028 11.6645C7.78388 12.3106 7.46379 13.1106 7.46379 14.0607C7.46379 15.0109 7.78199 15.8128 8.42028 16.457C9.05668 17.1031 9.84461 17.4261 10.7803 17.4261Z",
    fill: "#B8EF36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4792 8.53285C17.1667 8.53285 16.9053 8.42643 16.6932 8.2136C16.4792 8.00077 16.375 7.74423 16.375 7.44399C16.375 7.14375 16.4811 6.88341 16.6932 6.66298C16.9053 6.44444 17.1667 6.33423 17.4792 6.33423C17.7918 6.33423 18.0342 6.44444 18.2463 6.66298C18.4604 6.88341 18.5645 7.14185 18.5645 7.44399C18.5645 7.74613 18.4585 8.00077 18.2463 8.2136C18.0342 8.42833 17.7785 8.53285 17.4792 8.53285Z",
    fill: "#B8EF36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2842 9.36133H16.6553V18.7582H18.2842V9.36133Z",
    fill: "#B8EF36"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1721_5227"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.7318,
    height: 12.6691,
    fill: "white",
    transform: "translate(5.83301 6.33423)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiAssistantSmallIc);
export default __webpack_public_path__ + "static/media/ai_assistant_small_ic.a49ef1b22a8ff44ffd2957473fbcc277.svg";
export { ForwardRef as ReactComponent };